import { MutationTree } from 'vuex';
import * as TYPES from './types';
import { IState } from './state';
import { Message } from 'element-ui';
import Vue from 'vue';

export const mutations: MutationTree<any> = {
    // 改变全局搜索值
    [TYPES.CHANGE_SEARCH_KEY](state: IState, payload) {
        state.globalSearchObj = payload;
    },

    // 获取全局搜索值
    [TYPES.GLOBAL_SEARCH_META.REQUEST](state: IState, payload) {
        state.globalSearchList.loading = true;
    },
    // 获取全局搜索值
    [TYPES.GLOBAL_SEARCH_META.SUCCESS](state: IState, payload) {
        state.globalSearchList.loading = false;
        state.globalSearchList.infos =  payload.res.Data && payload.res.Data || { total: 0, data: []};
    },
    // 获取全局搜索值
    [TYPES.GLOBAL_SEARCH_META.FAILED](state: IState, payload) {
        state.globalSearchList.loading = false;
        state.globalSearchList.infos = {total: 0, data: []};
    }
};
